import React from 'react'
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom'
import {
    getAcPageUrl,
    getApprovalPageUrl,
    getHomeUrl,
    getIapPageUrl,
    getIogPageUrl,
    getMappingsPageUrl,
    getStartWorkflowPageUrl,
    getWorkflowHistoryPageUrl,
    getDynamicExecutionPageUrl,
    getRuleGroupPageUrl,
    getExclusionGroupPageUrl,
} from '../backend/internalUrls'
import AcPage from './ac/AcPage'
import IapPage from './Iap/IapPage'
import IogPage from './Iog/IogPage'
import StartWorkflowPage from './workflow/StartWorkflowPage'
import WorkflowHistoryPage from './workflow/WorkflowHistoryPage'
import DynamicExecutionHistoryPage from './dnc/executions/DynamicExecutionHistoryPage'
import Layout from './basic/Layout'
import Menu from './navigation/menu'
import '../css/polarisFixes.css'
import WelcomePage from './WelcomePage'
import GogglesRedirects from './GogglesRedirects'
import MappingsPage from './admin/MappingsPage'
import ApprovalPage from './admin/ApprovalPage'
import {FeaturesProvider} from '../context/FeaturesContext'
import ContextProvider from '../context/ContextProvider'
import {GlobalDataProvider} from '../context/GlobalDataProvider'
import RuleGroupsPage from './dnc/rule/RuleGroupsPage'
import ExclusionGroupsPage from './dnc/exclusion/ExclusionGroupsPage'

const App: React.FC = (props) => {

    const providers: React.FC[] = [
        FeaturesProvider,
        GlobalDataProvider,
    ]

    return (
        <BrowserRouter>
            <ContextProvider providers={providers}>
                <Layout navigation={<Menu/>}>
                    <Switch>
                        <Route exact path={getAcPageUrl()} component={AcPage}/>
                        <Route exact path={getAcPageUrl(':acId')} component={AcPage}/>
                        <Route exact path={getIapPageUrl()} component={IapPage}/>
                        <Route exact path={getIapPageUrl(':iapId')} component={IapPage}/>
                        <Route exact path={getIogPageUrl()} component={IogPage}/>
                        <Route exact path={getIogPageUrl(':iogId')} component={IogPage}/>
                        <Route exact path={getRuleGroupPageUrl()} component={RuleGroupsPage}/>
                        <Route exact path={getRuleGroupPageUrl(':ruleGroupName')} component={RuleGroupsPage}/>
                        <Route exact path={getRuleGroupPageUrl(':ruleGroupName', ':ruleName')} component={RuleGroupsPage}/>
                        <Route exact path={getExclusionGroupPageUrl()} component={ExclusionGroupsPage}/>
                        <Route exact path={getExclusionGroupPageUrl(':exclusionGroupName')} component={ExclusionGroupsPage}/>
                        <Route exact path={getStartWorkflowPageUrl()} component={StartWorkflowPage}/>
                        <Route exact path={getWorkflowHistoryPageUrl()} component={WorkflowHistoryPage}/>
                        <Route exact path={getWorkflowHistoryPageUrl(':executionId')} component={WorkflowHistoryPage}/>
                        <Route exact path={getDynamicExecutionPageUrl()} component={DynamicExecutionHistoryPage}/>
                        <Route exact path={getDynamicExecutionPageUrl(':executionId')} component={DynamicExecutionHistoryPage}/>
                        <Route exact path={getHomeUrl()} component={WelcomePage}/>
                        <Route exact path={getMappingsPageUrl()} component={MappingsPage}/>
                        <Route exact path={getApprovalPageUrl()} component={ApprovalPage}/>
                        <Route exact path={getApprovalPageUrl(':submissionId')} component={ApprovalPage}/>
                        <GogglesRedirects/>
                        <Redirect to={getHomeUrl()}/>
                    </Switch>
                </Layout>
            </ContextProvider>
        </BrowserRouter>
    )
}

export default App
